import Component from "../abstracts/Component";
import slick from "slick-carousel";
import _ from "lodash";

export default class EditorialProductsSliderComponent extends Component {
    get SELECTORS() {
        return {
            main: '.carousel-wrapper',
            prevArrow: '[data-prev-arrow]',
            nextArrow: '[data-next-arrow]',
            carouselWrapper: '.w-editorial-products-carousel-wrapper'
        };
    }

    constructor(element) {
        super();

        this.carouselWrapper = $(this.SELECTORS.carouselWrapper);
    }

    initCarousel() {
        this.carouselWrapper.slick({
            slidesToShow: 2.03,
            mobileFirst: true,
            dots: false,
            infinite: false,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.15,
                    slidesToScroll: 2,
                    prevArrow: "<button class='icon-chevron-left'></button>",
                    nextArrow: "<button class='icon-chevron-right'></button>",
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3.06,
                }
            }]
        })
    }

    render() {
        super.render();
        this.initCarousel();
        const ctx = this;

        $(window).on('resize', _.debounce(function () {
            $(ctx.carouselWrapper).slick('unslick');
            ctx.initCarousel();
        }, 500));
    }
}
